import React, { Component } from 'react'

class HeaderBar extends Component {

    render() {
        return (
            <div>
                
            </div>
        );
    }
}

export default HeaderBar
